import { useCallback, useEffect, useState } from 'react';

type useJQueryReturn = { isLoaded: boolean };

export const jQueryUri =
  'https://ajax.googleapis.com/ajax/libs/jquery/3.6.4/jquery.min.js';

export default function useJQuery(): useJQueryReturn {
  const [isLoaded, setIsLoaded] = useState(false);
  const onJqueryLoad = useCallback(() => setIsLoaded(true), []);

  useEffect(() => {
    let jqueryScript = document.getElementById(
      'jquery-script'
    ) as HTMLScriptElement;

    if (!jqueryScript) {
      jqueryScript = document.createElement('script');
      jqueryScript.src = jQueryUri;
      jqueryScript.id = 'jquery-script';
      document.body.appendChild(jqueryScript);

      jqueryScript.addEventListener('load', onJqueryLoad);
    } else if (window['jQuery'] !== undefined) {
      setIsLoaded(true);
    } else {
      jqueryScript.addEventListener('load', onJqueryLoad);
    }

    return () => {
      jqueryScript.removeEventListener('load', onJqueryLoad);
    };
  }, []);

  return {
    isLoaded,
  };
}
